'use client';
import React, { useEffect, useState, useRef } from 'react';
import './Index.css';
import Constants from '../../utils/constants';
import HttpService from '../../services/HttpService';
import { useStore } from '../../utils/store';

import TextFieldComponent from '../../components/form/TextFieldComponent';

import {
  Box,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import DatePickerComponent from '../../components/DatePickerComponent';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import Grid from '@mui/material/Grid2';
import AddButtonComponent from '../../components/form/AddButtonComponent';
import FormFieldData from '../../Models/FormFieldData';
import CommonForm from '../../components/form/CommonForm';
import { getCurrentDate, handleErrorMessage } from '../../utils/storageUtil';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import NoActionTable from '../../components/NoActionTable';
import { Edit } from '@mui/icons-material';
const CompanyProfile: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const [httpError, setHttpError] = useState({
    message: '',
    open: false,
  });
  const [loading, setLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [s3FileCurrent, setS3FileCurrent] = useState<any>(null);
  const [s3FileCurrentRemoved, setS3FileCurrentRemoved] = useState<any>(null);
  const [logoFile, setLogoFile] = useState<any>(null);
  const [financialRecords, setFinancialRecords] = useState<any[]>([]);
  const [documentTypeListLabour, setDocumentTypeListLabour] = useState<any[]>(
    []
  );
  const [documentTypeListMobileAssets, setDocumentTypeListMobileAssets] =
    useState<any[]>([]);
  const [inductionsList, setInductionsList] = useState<any[]>([]);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [errorType, setErrorType] = useState<any>('error');
  const [loadingSave, setLoadingSave] = useState(false);
  const [docTypeDialog, setDocTypeDialog] = useState(false);
  const [docType, setDocType] = useState<any>('');
  const [companyForm, setCompanyForm] = useState({
    companyName: '',
    abn: '',
    address: '',
    contactNumber: '',
    email: '',

    id: null,
  });
  const [errors, setErrors] = useState({
    companyName: '',
    abn: '',
    address: '',
    contactNumber: '',
    email: '',
  });
  const [docTypeForm, setDocTypeForm] = useState<any>({
    id: { required: false, value: null },
    name: { required: true, value: '' },
  });
  // Fetch single term record
  const fetchSingleRecord = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.companyProfileURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        null
      );
      if (response.data) {
        handleRowClick(response.data);
      } else {
        //setErrorMessage("Failed to fetch record. Please try again.");
      }
    } catch (error) {
      //setErrorMessage("Failed to fetch record. Please try again.");
    }
  };
  const columnsLabours: any[] = [
    {
      field: 'name',
      headerName: 'Name',
    },
  ];
  const fetchDocumentTypes = async (type: any) => {
    try {
      let documentType: any = 'fetchDocumentTypes';
      if (type === 'quoteInductions') {
        documentType = 'fetchQuoteInductions';
      }
      const URL = `${Constants.apiURL}${Constants.refBundleURL}/${documentType}`;
      const response = await HttpService.get(
        URL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { type: type }
      );
      if (response.data) {
        if (type === 'labour') setDocumentTypeListLabour(response.data);
        if (type === 'mobileasset')
          setDocumentTypeListMobileAssets(response.data);
        if (type === 'quoteInductions') setInductionsList(response.data);
      }

      console.log('GET Response:', response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Fetch data when component loads or dependencies change
  useEffect(() => {
    if (isInitialLoad.current) {
      fetchSingleRecord();
      fetchDocumentTypes('labour');
      fetchDocumentTypes('mobileasset');
      fetchDocumentTypes('quoteInductions');
      isInitialLoad.current = false;
    }
  }, []);

  // Handle form input change
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setCompanyForm((prevData) => ({ ...prevData, [name]: value }));
    validateField(e.target);
  };
  const handleInputChangeDocType = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setDocTypeForm((prevData: any) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };
  const handleInputChangeFinancial = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    keyName: string,
    index: number
  ) => {
    const { name, value } = e.target;
    if (value !== '' && !/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    let oveheadValue = 0;
    let forecastValue = 0;
    let overheadPercentage = 0;
    if (keyName === 'overhead') {
      oveheadValue = parseFloat(value || '0');
      forecastValue = financialRecords[index]['forecast'];
    }
    if (keyName === 'forecast') {
      forecastValue = parseFloat(value || '0');
      oveheadValue = financialRecords[index]['overhead'];
    }

    overheadPercentage = forecastValue
      ? ((oveheadValue ?? 0) * 100) / (forecastValue ?? 0)
      : 0;

    setFinancialRecords((prevData: any[]) => {
      const updatedData = [...prevData];
      if (updatedData[index]) {
        updatedData[index] = {
          ...updatedData[index],
          [keyName]: value,
          overheadPercent: overheadPercentage.toFixed(2),
        };
      }
      return updatedData;
    });
    validateField(e.target);
  };
  const handleFinancialBlur = (keyName: string, index: number) => {
    setFinancialRecords((prevData: any[]) => {
      const updatedData = [...prevData];
      if (!updatedData[index]) return prevData;
      const raw = updatedData[index][keyName];
      const num = parseFloat(raw);
      const formatted = isNaN(num) ? '' : num.toFixed(2);
      const oveheadValue =
        keyName === 'overhead'
          ? parseFloat(formatted || '0')
          : parseFloat(updatedData[index].overhead || '0');
      const forecastValue =
        keyName === 'forecast'
          ? parseFloat(formatted || '0')
          : parseFloat(updatedData[index].forecast || '0');
      const overheadPercentage = forecastValue
        ? ((oveheadValue ?? 0) * 100) / (forecastValue ?? 0)
        : 0;
      updatedData[index] = {
        ...updatedData[index],
        [keyName]: formatted,
        overheadPercent: overheadPercentage.toFixed(2),
      };
      return updatedData;
    });
  };
  const handleFinancialDate = (value: any, keyName: string, index: number) => {
    const expiryDateValue =
      value.year() + '-' + (value.month() + 1) + '-' + value.date();
    setFinancialRecords((prevData: any[]) => {
      const updatedData = [...prevData];
      if (updatedData[index]) {
        updatedData[index] = {
          ...updatedData[index],
          [keyName]: expiryDateValue,
        };
      }
      return updatedData;
    });
  };
  const validateField = async (element: any) => {
    const newErrors: any = {};
    if (!element.value.trim()) {
      newErrors[element.name] = 'this is required field';
      if (element.name === 'abn') {
        const abnRegex = /^\d{11}$/;
        if (!abnRegex.test(element.value) && element.value) {
          newErrors.abn = 'Invalid ABN. Must be 11 digits.';
        }
      }
      if (element.name === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(element.value)) {
          newErrors.email = 'Invalid email address.';
        }
      }
    }
    setErrors(newErrors);
    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  // Handle record creation or update
  const handleSave = async () => {
    setLoading(true);
    const reqData: any = companyForm;
    reqData['financialRecords'] = financialRecords;
    if (s3FileCurrentRemoved) {
      reqData['s3FileCurrentRemoved'] = s3FileCurrentRemoved;
    }
    const endpoint = `${Constants.apiURL + Constants.companyProfileURL}`;
    let response: any;
    try {
      if (reqData['id']) {
        response = await HttpService.put(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      } else {
        response = await HttpService.post(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      }

      if (response.success) {
        if (logoFile)
          await HttpService.handlePresignedURL(
            logoFile[0],
            'company_profile',
            response.data.id,
            getAdmin()
          );
        clearForm();
      }
    } catch (error: any) {
      console.error(`POST Error:`, error);
      setHttpError({
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // Clear form and reset state
  const clearForm = () => {
    setAlertOpen(true);
    setHttpError({ message: '', open: false });
    window.location.reload();
  };
  const handleFileChange = async (file: any) => {
    setLogoFile(file);
  };

  function handleCloseAlert() {
    setHttpError((prev) => {
      return {
        ...prev,
        open: false,
      };
    });
  }

  const handleRemove = async (fileData: any) => {
    // const updatedFiles = uploadFile.filter((file: any) => file !== fileData); // Create a new array
    setLogoFile(null);
  };
  const handleCurrentFilesRemove = async (fileData: any) => {
    // const updatedFiles = uploadFile.filter((file: any) => file !== fileData); // Create a new array
    setS3FileCurrent(null);
    setS3FileCurrentRemoved(fileData);
  };
  const AddFinancial = async () => {
    // const updatedFiles = uploadFile.filter((file: any) => file !== fileData); // Create a new array
    setFinancialRecords((prevRecords) => [
      ...prevRecords,
      {
        overhead: '',
        forecast: '',
        overheadPercent: '',
        effectiveDate: getCurrentDate(),
        expiryDate: getCurrentDate(),
        reviewDate: getCurrentDate(),
      },
    ]);
  };

  const handleRowClick = (record: any) => {
    setCurrentRecord(record);
    setCompanyForm({
      companyName: record.companyName,
      abn: record.abn,
      address: record.address,
      contactNumber: record.contactNumber,
      email: record.email,
      id: record.id,
    });
    setS3FileCurrent(record.media ? [record.media] : []);
    setFinancialRecords(
      (record.financial || []).map((fr: any) => {
        const overheadNum = parseFloat(fr.overhead);
        const forecastNum = parseFloat(fr.forecast);
        return {
          ...fr,
          overhead: isNaN(overheadNum) ? fr.overhead : overheadNum.toFixed(2),
          forecast: isNaN(forecastNum) ? fr.forecast : forecastNum.toFixed(2),
        };
      })
    );
  };

  const formFields: FormFieldData[] = [
    {
      label: 'Company Name',
      isRequired: true,
      name: 'companyName',
      onChange: handleInputChange,
      size: 6,
      type: 'textfield',
      value: companyForm.companyName,
      validationRules: [
        (value) => (!value ? 'Company Name is required' : null),
      ],
    },
    {
      label: 'ABN',
      isRequired: true,
      name: 'abn',
      onChange: handleInputChange,
      size: 6,
      type: 'textfield',
      value: companyForm.abn,
      validationRules: [
        (value) => (!value ? 'ABN is required' : null),
        (value) => (value && value.length !== 11 ? 'Invalid ABN Number' : null),
      ],
    },
    {
      label: 'Address',
      isRequired: true,
      name: 'address',
      onChange: handleInputChange,
      size: 12,
      type: 'textfield',
      value: companyForm.address,
      validationRules: [(value) => (!value ? 'Address is required' : null)],
    },
    {
      name: 'email',
      label: 'Email ID',
      value: companyForm.email,
      onChange: handleInputChange,
      isRequired: true,
      size: 6,
      type: 'textfield',
      validationRules: [
        (value) => (!value ? 'Email is required' : null),
        (value) =>
          value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
            ? 'Invalid email address'
            : null,
      ],
    },
    {
      name: 'contactNumber',
      label: 'Phone Number',
      value: companyForm.contactNumber,
      onChange: handleInputChange,
      isRequired: false,
      size: 6,
      type: 'textfield',
      validationRules: [
        (value) =>
          value && !/^[+]?[0-9\s\-()]{7,15}$/i.test(value)
            ? 'Invalid Phone Number'
            : null,
      ],
    },
    {
      label: 'Logo',
      multiple: false,
      isRequired: false,
      name: 'fileURLComm',
      value: logoFile ?? [],
      acceptFiles: 'image/*',
      existingFiles: companyForm.id ? s3FileCurrent : null,
      onChange: (file: any) => {
        handleFileChange(file);
      },
      onRemoveFile: (file: any) => {
        handleRemove(file);
      },
      onRemoveExistingFile: (file: any) => {
        handleCurrentFilesRemove(file);
      },
      onOpenFile: (id) => {
        HttpService.handleDownloadFile(id, getAdmin());
      },
      size: 12,
      type: 'file',
    },
  ];
  const formFieldsDocType: FormFieldData[] = [
    {
      name: 'name',
      label: 'Name',
      value: docTypeForm.name.value,
      onChange: handleInputChangeDocType,
      isRequired: true,
      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'name is required' : '')],
    },
  ];
  const clearFormDocType = () => {
    setDocTypeForm({
      id: { required: false, value: null },
      name: { required: true, value: '' },
    });
    setDocTypeDialog(false);
    fetchDocumentTypes(docType);
  };
  const handleSaveType = async () => {
    setLoadingSave(true);
    const reqData: any = {
      id: docTypeForm.id.value,
      name: docTypeForm.name.value,
      type: docType,
    };
    const endpoint = `${Constants.apiURL + Constants.refBundleURL}/${docType === 'quoteInductions' ? 'quoteInductions' : 'documentTypes'}`;
    let response: any;
    try {
      if (docTypeForm.id.value) {
        response = await HttpService.put(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      } else {
        response = await HttpService.post(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      }

      if (response.success) {
        clearFormDocType();
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setHttpError({ open: true, message: handleErrorMessage(error) });
    } finally {
      setLoadingSave(false);
    }
  };

  const docTypeFormContent = () => {
    return (
      <CommonForm
        singlePage={true}
        fields={formFieldsDocType}
        onCancel={() => {}}
        formReset={clearForm}
        formTitle={
          docType === 'labour'
            ? 'Labour Document Type'
            : docType === 'mobileasset'
              ? 'Mobile Assets Document Type'
              : docType === 'quoteInductions'
                ? 'Induction'
                : ''
        }
        isLoading={loadingSave}
        isUpdate={docTypeForm.id.value ? true : false}
        onSave={handleSaveType}
        actionButtonPosition="bottom"
      />
    );
  };
  const renderExtraFields = () => {
    return (
      <Grid container spacing={2} key={'extrafields'} sx={{ marginBottom: 1 }}>
        <Grid size={12} className="mt-2 mb-2">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              component={'h6'}
              sx={{ mt: 3, mb: 3 }}
              key={'lbk_financial'}
            >
              Company Overhead
            </Typography>
            <AddButtonComponent
              keyName="add_finbtn"
              label="Add New"
              onClick={() => {
                AddFinancial();
              }}
            />
          </Box>
          <TableContainer sx={{ mt: 2 }} component={Paper}>
            <Table>
              <TableHead>
                <TableRow
                  className="headrowtbl"
                  key={'headrow_'}
                  style={{ background: ' rgba(0, 244, 255, 0.06)' }}
                >
                  <TableCell
                    key={'tblheadclldesc_'}
                    className="boldfont"
                    style={{ width: '130px' }}
                  >
                    Overhead ($)
                  </TableCell>
                  <TableCell
                    key={'tblheadcllitemc_'}
                    className="boldfont"
                    style={{ width: '150px' }}
                  >
                    Forecast Revenue
                  </TableCell>
                  <TableCell
                    key={'tblbotblheadclliqty_'}
                    className="boldfont"
                    style={{ width: '130px' }}
                  >
                    Overhead (%)
                  </TableCell>
                  <TableCell
                    key={'tblheadcllcost_'}
                    className="boldfont"
                    style={{ width: '150px' }}
                  >
                    Effective Date
                  </TableCell>
                  <TableCell
                    key={'tblheadcluom_'}
                    className="boldfont"
                    style={{ width: '150px' }}
                  >
                    Expiry Date
                  </TableCell>
                  <TableCell
                    key={'tblheadclttl_'}
                    className="boldfont"
                    style={{ width: '150px' }}
                  >
                    Review Date
                  </TableCell>
                </TableRow>
              </TableHead>
              {financialRecords.length > 0 && (
                <TableBody key="tblbody_fin">
                  {financialRecords.map((fRecord: any, index: number) => {
                    return (
                      <TableRow key={'headrow_' + index}>
                        <TableCell key={'tblheadclldesc_' + index}>
                          <TextFieldComponent
                            label=""
                            keyName={'overhead_single_' + index}
                            name={'overhead_single_' + index}
                            value={fRecord.overhead}
                            type="text"
                            onChange={(e) => {
                              handleInputChangeFinancial(e, 'overhead', index);
                            }}
                            onBlur={() =>
                              handleFinancialBlur('overhead', index)
                            }
                            errorStr={''}
                            placeholder=""
                            isRequired={false}
                          />
                        </TableCell>
                        <TableCell key={'tblfin_forcst'}>
                          <TextFieldComponent
                            label=""
                            keyName={'forecast_single_' + index}
                            name={'forecast_single_' + index}
                            type="text"
                            value={fRecord.forecast}
                            onChange={(e) => {
                              handleInputChangeFinancial(e, 'forecast', index);
                            }}
                            onBlur={() =>
                              handleFinancialBlur('forecast', index)
                            }
                            errorStr={''}
                            placeholder=""
                            isRequired={false}
                          />
                        </TableCell>
                        <TableCell key={'tblbotblheadclliqty_' + index}>
                          {fRecord.overheadPercent}%
                        </TableCell>
                        <TableCell key={'tblheadclleffectiveDate_' + index}>
                          <DatePickerComponent
                            keyName={'effectiveDate_single' + index}
                            isRequired={false}
                            label=""
                            errorStr={''}
                            name={'effectiveDate_single' + index}
                            onChange={(value) => {
                              handleFinancialDate(
                                value,
                                'effectiveDate',
                                index
                              );
                            }}
                            defaultValue={
                              fRecord.effectiveDate
                                ? fRecord.effectiveDate
                                : getCurrentDate()
                            }
                          />
                        </TableCell>
                        <TableCell key={'tblheadcluom_' + index}>
                          <DatePickerComponent
                            keyName={'expiryDate_single' + index}
                            isRequired={false}
                            label=""
                            errorStr={''}
                            name={'expiryDate_single' + index}
                            onChange={(value) => {
                              handleFinancialDate(value, 'expiryDate', index);
                            }}
                            defaultValue={
                              fRecord.expiryDate
                                ? fRecord.expiryDate
                                : getCurrentDate()
                            }
                          />
                        </TableCell>
                        <TableCell
                          key={'tblheadclttl_' + index}
                          style={{ width: '130px' }}
                        >
                          <DatePickerComponent
                            keyName={'reviewDate_single' + index}
                            isRequired={false}
                            label=""
                            errorStr={''}
                            name={'reviewDate_single' + index}
                            onChange={(value) => {
                              handleFinancialDate(value, 'reviewDate', index);
                            }}
                            defaultValue={
                              fRecord.reviewDate
                                ? fRecord.reviewDate
                                : getCurrentDate()
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Grid>
        <Grid size={12} className="mt-2 mb-2">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              component={'h6'}
              sx={{ mt: 3, mb: 3 }}
              key={'lbk_financial'}
            >
              Labour Document Types
            </Typography>
            <AddButtonComponent
              keyName="add_finbtn"
              label="Add New"
              onClick={() => {
                setDocType('labour');
                setDocTypeDialog(true);
              }}
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <NoActionTable
            rows={documentTypeListLabour}
            columns={columnsLabours}
            handleRowClick={(row) => {
              setDocType('labour');
              setDocTypeForm({
                id: { required: false, value: row.id },
                name: { required: true, value: row.name },
              });
              setDocTypeDialog(true);
            }}
            handleStatus={() => {}}
          />
        </Grid>
        <Grid size={12} className="mt-2 mb-2">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              component={'h6'}
              sx={{ mt: 3, mb: 3 }}
              key={'lbk_financial'}
            >
              Mobile Document Types
            </Typography>
            <AddButtonComponent
              keyName="add_finbtn"
              label="Add New"
              onClick={() => {
                setDocType('mobileasset');
                setDocTypeDialog(true);
              }}
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <NoActionTable
            rows={documentTypeListMobileAssets}
            columns={columnsLabours}
            handleRowClick={(row) => {
              setDocType('mobileasset');
              setDocTypeForm({
                id: { required: false, value: row.id },
                name: { required: true, value: row.name },
              });
              setDocTypeDialog(true);
            }}
            handleStatus={() => {}}
          />
        </Grid>
        <Grid size={12} className="mt-2 mb-2">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              component={'h6'}
              sx={{ mt: 3, mb: 3 }}
              key={'lbk_financial'}
            >
              Inductions
            </Typography>
            <AddButtonComponent
              keyName="add_finbtn"
              label="Add New"
              onClick={() => {
                setDocType('quoteInductions');
                setDocTypeDialog(true);
              }}
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <NoActionTable
            rows={inductionsList}
            columns={columnsLabours}
            handleRowClick={(row) => {
              setDocType('quoteInductions');
              setDocTypeForm({
                id: { required: false, value: row.id },
                name: { required: true, value: row.name },
              });
              setDocTypeDialog(true);
            }}
            handleStatus={() => {}}
          />
        </Grid>
      </Grid>
    );
  };
  return (
    <Stack>
      <CommonForm
        fields={formFields}
        onCancel={() => {}}
        formReset={clearForm}
        formTitle={'Company Profile'}
        isLoading={loading}
        isUpdate={true}
        onSave={handleSave}
        customComponents={renderExtraFields()}
        isRemoveCancel={true}
        actionButtonPosition="top"
      />
      <AlertMessageComponent
        type={'error'}
        open={httpError.open}
        handleClose={handleCloseAlert}
        message={httpError.message}
      />
      <SimpleDialogComponent
        title={''}
        dialogContent={docTypeFormContent()}
        open={docTypeDialog}
        handleClose={() => {
          setDocTypeDialog(false);
          clearForm();
        }}
      />
    </Stack>
  );
};

export default CompanyProfile;
